<template>
  <div>
    <DataTable
      :value="activityTypes"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedActivityTypes"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityTypes"
    >
      <template #empty> No types found. </template>
      <template #loading> Loading types data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="activityTypeCode"
        header="Code"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.activityTypeCode }}
          </div>
        </template>
      </Column>
      <Column
        field="activityTypeName"
        header="Name"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.activityTypeName }}
          </div>
        </template>
      </Column>
      <Column
        field="kind"
        header="Shows on"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ kindLabel(slotProps.data.kind) }}
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column
        field="colourCode"
        header="ColourCode"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.colourCode && slotProps.data.colourCode.label ? slotProps.data.colourCode.label : "" }}
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editActivityType(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <SettingDeleteConfirm
      :visible.sync="displayDeleteConfirm"
      :row="rowToDelete"
      list="activityTypes"
      :label="rowToDelete ? String(rowToDelete.activityTypeName || '') : ''"
      what="task or event type"
      @deleted="row => $emit('deleted', row)"
    />
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
import SettingDeleteConfirm from '../SettingDeleteConfirm.vue'
import { kindLabel } from '../../activityKind.js'
export default {
  mixins: [PermissionMixin],
  components: { SettingDeleteConfirm },
  props: [
    'activityTypes',
    'loading'
  ],
  data: () => ({
    rowToDelete: null,
    displayDeleteConfirm: false,
    selectedActivityTypes: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    kindLabel,
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteActivityType(data)
            }
          }
        )
      }
      return buttons
    },
    // RT1: ask, then delete (SettingDeleteConfirm); it used to do nothing
    deleteActivityType(row) {
      this.rowToDelete = row
      this.displayDeleteConfirm = true
    },
    editActivityType(activityType) {
      this.$emit('edit-activity-type', activityType)
    }
  }
}
</script>

<style>

</style>